export enum Quelle {
  DB_BUSINESS_NAVIGATOR,
  DB_NAVIGATOR,
  RIS_STATIONS,
  OEBB,
  SBB,
  IRIS,
  MUY_VLAK,
  NS,
  PKP,
  SNCF_CONNECT,
  ENTUR,
  UNBEKANNT = 999,
}

export function displayName(reiseQuelle: Quelle) {
  switch (reiseQuelle) {
    case Quelle.DB_BUSINESS_NAVIGATOR:
      return 'DB Business Navigator';
    case Quelle.DB_NAVIGATOR:
      return 'DB Navigator';
    case Quelle.OEBB:
      return 'ÖBB';
    case Quelle.SBB:
      return 'SBB Mobile';
    case Quelle.IRIS:
      return 'IRIS';
    case Quelle.MUY_VLAK:
      return 'Můj vlak';
    case Quelle.NS:
      return 'NS';
    case Quelle.PKP:
      return 'PKP Intercity';
    case Quelle.SNCF_CONNECT:
      return 'SNCF Connect';
    case Quelle.RIS_STATIONS:
      return 'RIS-Stations';
    case Quelle.ENTUR:
      return 'Entur';
    case Quelle.UNBEKANNT:
      return 'Unbekannt (und undefiniert)';
    default:
      return 'Unbekannt';
  }
}
